const benefits = [
  {
    icon: 'ri-time-line',
    title: 'Extended Visit Times',
    description: 'No rushed 7-minute checkups. Dr. Leder blocks ample time for every appointment so you leave with real answers, a real plan, and real confidence — not just another prescription.',
  },
  {
    icon: 'ri-search-eye-line',
    title: 'Root-Cause Investigation',
    description: 'Every protocol begins with an in-depth investigation into your complete health history, lifestyle, environment, and biochemical markers — uncovering the true "why" behind your symptoms.',
  },
  {
    icon: 'ri-flask-line',
    title: 'Advanced Therapies',
    description: 'Access treatments unavailable at most practices: IV nutrient infusions, EDTA chelation for heavy metals, bio-identical hormones, orthomolecular medicine, and functional nutrition protocols.',
  },
  {
    icon: 'ri-user-heart-line',
    title: 'True Partnership',
    description: 'Patient requests for specific testing are always honored. Dr. Leder works alongside you — listening, collaborating, and adjusting. You are never a chart number here.',
  },
  {
    icon: 'ri-award-line',
    title: '40+ Years of Expertise',
    description: 'Four decades of functional medicine experience across thousands of complex cases means Dr. Leder brings rare diagnostic insight that standard medical training simply does not provide.',
  },
  {
    icon: 'ri-article-line',
    title: 'Community Educator',
    description: 'Dr. Leder authors monthly holistic medicine articles for local Bergen County publications — a long-standing commitment to patient education, community health, and integrative medicine awareness.',
  },
];

const comparisons = [
  { label: 'Visit Length', us: 'Extended, unhurried one-on-one time', them: '7–15 minute appointment slots' },
  { label: 'Diagnostic Approach', us: 'Advanced root-cause functional testing', them: 'Standard lab panels only' },
  { label: 'Treatment Philosophy', us: 'Identify and address underlying causes', them: 'Prescribe for symptom suppression' },
  { label: 'Personalization', us: 'Fully individualized protocols', them: 'One-size-fits-all guidelines' },
  { label: 'IV & Chelation Therapies', us: 'Available in-office', them: 'Rarely offered, often dismissed' },
  { label: 'Psychology Integration', us: 'Counseling + orthomolecular psychiatry', them: 'Outside referral only' },
  { label: 'Physician Experience', us: '40+ years functional medicine', them: 'General practice focus' },
];

export default function BenefitsSection() {
  return (
    <>
      {/* Why Choose Us */}
      <section className="py-20 px-6 lg:px-12 bg-teal-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-14">
            <p className="text-teal-600 text-sm font-semibold tracking-widest uppercase mb-3">Why Patients Choose Dr. Leder</p>
            <h2 className="font-heading text-4xl lg:text-5xl font-bold text-teal-950 mb-5">
              A Different Kind of Medical Care
            </h2>
            <p className="text-gray-600 text-lg max-w-2xl mx-auto">
              Over 40 years refining an approach that delivers real results for patients the conventional system has failed — time and again.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {benefits.map((b, i) => (
              <div key={i} className="bg-white border border-teal-100 rounded-lg p-7 hover:border-teal-300 transition-colors">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-md mb-5">
                  <i className={`${b.icon} text-teal-700 text-2xl`}></i>
                </div>
                <h3 className="font-heading text-lg font-semibold text-teal-950 mb-3">{b.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{b.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Comparison Section */}
      <section className="py-20 px-6 lg:px-12 bg-white">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12">
            <p className="text-teal-600 text-sm font-semibold tracking-widest uppercase mb-3">Honest Comparison</p>
            <h2 className="font-heading text-4xl font-bold text-teal-950 mb-4">
              Functional Medicine vs. Conventional Care
            </h2>
            <p className="text-gray-600">
              A transparent look at how A Better Alternative Medical Center compares to standard care.
            </p>
          </div>

          <div className="border border-teal-100 rounded-lg overflow-hidden">
            <div className="grid grid-cols-3 text-white" style={{ background: '#0a3d35' }}>
              <div className="p-4 text-sm font-semibold text-teal-300">Category</div>
              <div className="p-4 text-sm font-semibold bg-teal-700 flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-checkbox-circle-fill text-base" style={{ color: '#f59e0b' }}></i>
                </div>
                A Better Alternative
              </div>
              <div className="p-4 text-sm font-semibold text-teal-400">Conventional Doctor</div>
            </div>
            {comparisons.map((row, i) => (
              <div key={i} className={`grid grid-cols-3 border-b border-teal-50 last:border-0 ${i % 2 === 0 ? 'bg-white' : 'bg-teal-50'}`}>
                <div className="p-4 text-sm font-semibold text-teal-900 border-r border-teal-100">{row.label}</div>
                <div className="p-4 text-sm text-teal-800 font-medium border-r border-teal-100">{row.us}</div>
                <div className="p-4 text-sm text-gray-400">{row.them}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
